import { useCallback, useLayoutEffect, useRef } from 'react';

function useScrollSync() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  var timeoutId = useRef();
  var handleScroll = useCallback(function (event) {
    var syncedRefs = refs.filter(function (ref) {
      return ref.current !== event.target;
    });
    var targetScrollLeft = event.target.scrollLeft;
    clearTimeout(timeoutId.current);
    syncedRefs.forEach(function (ref) {
      removeEvent(ref);
      ref.current.style.willChange = 'scroll-position';
      ref.current.scrollLeft = targetScrollLeft;
    });
    timeoutId.current = setTimeout(function () {
      syncedRefs.forEach(function (ref) {
        addEvent(ref);
        ref.current.style.willChange = '';
      });
    }, 120);
  }, [refs]);
  var addEvent = useCallback(function (ref) {
    ref.current.addEventListener('scroll', handleScroll, {
      passive: true
    });
  }, [handleScroll]);
  var removeEvent = useCallback(function (ref) {
    ref.current.removeEventListener('scroll', handleScroll, {
      passive: true
    });
  }, [handleScroll]);
  useLayoutEffect(function () {
    refs.forEach(addEvent);
    return function () {
      clearTimeout(timeoutId.current);
      refs.forEach(removeEvent);
    };
  }, []);
}

export default useScrollSync;